<template>
    <div class="todo-item">
        <div class="area-box">
            <textarea v-model="message" class="descContent font30" placeholder="请输入要添加的提醒事件，添加成功后将会在设定好的时间提醒你哦～"
                adjust-position="false" cursor-spacing="300" maxlength="300">
                </textarea>
            <div class="textarea-counter">{{ message.length }}/300</div>
        </div>
        <div class="add-box" @click="showEmployeePopup">
            <div class="flex space-between flex-y-center" v-if="selectedEmployee" style="width:100%">
                <div class="flex flex-y-center flex-1">
                    <img :src="selectedEmployee.avatar" class="head-icon" alt="" />
                    <div>{{ selectedEmployee.username }}</div>
                </div>
                <van-icon name="arrow" color="#CCCCCC" />
            </div>
            <div class="flex flex-between flex-y-center" v-else>
                <div>添加顾客</div>
                <van-icon name="arrow" color="#CCCCCC" />
            </div>
        </div>
        <div class="bottom-box flex flex-between flex-y-center" @click="showTimePopup">
            <div class="flex flex-y-center">
                <van-icon name="clock-o" color="#A0ACB5" />
                <div class="time">提醒时间</div>
            </div>
            <div class="flex flex-y-center">
                <div class="follow">
                    {{ remindDate ? remindDate : '选择时间' }}
                </div>
                <van-icon name="arrow" color="#CCCCCC" size="0.3rem" />
            </div>
        </div>
        <van-popup v-model="showEmployee" round position="bottom" get-container="#app" closeable>
            <div class="popup-container">
                <div class="title">选择顾客</div>
                <form action="/">
                    <van-search class="search-button" v-model="searchValue" @search="onSearch" @clear="onClear"
                        placeholder="请输入顾客姓名"
                        left-icon="https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-07/search.png">
                    </van-search>
                </form>
                <div class="operator flex flex-col flex-y-center">
                    <van-list :finished="finishedForEmployee" @load="loadEmployeeList" v-model="loadingForEmployee"
                        finished-text="没有更多了" :offset="20" :immediate-check="false">
                        <div class="line flex flex-start flex-y-center" v-for="(item, index) in listForEmployee" :key="index"
                            @click="employeeClick(item)">
                            <img class="head" :src="item.avatar" alt="" />
                            <div class="flex-1">{{ item.username }}</div>
                        </div>
                    </van-list>
                    <van-button round size="mini" class="save-button" @click="cancel">取消</van-button>
                </div>
            </div>
        </van-popup>
        <!-- 选择提醒时间 -->
        <van-popup v-model="showTime" position="bottom" custom-style="height: 40%;" @click-overlay="closeTimePopup">
            <van-datetime-picker type="date" v-model="dateTime" @confirm="onTimeConfirm" @cancel="closeTimePopup"
                :min-date="minDate" :max-date="maxDate" :formatter="formatter" />
        </van-popup>
    </div>
</template>

<script>
import request from "@/utils/request";
import { Toast } from 'vant'
import * as com from "../../../utils/util";

export default {
    name: 'createToDo',
    model: {
        prop: 'todoDetail',
        event: 'change'
    },
    props: {
        todoDetail: {
            type: Object,
        },
    },
    computed: {
        message: {
            get() {
                return this.todoDetail.message;
            },
            set(value) {
                this.todoDetail.message = value
                this.update()
            },
        },
        selectedEmployee: {
            get() {
                return this.todoDetail.taskContactList[0];
            },
            set(value) {
                this.$set(this.todoDetail.taskContactList, 0, value)
                this.update()
            },
        },
        remindDate: {
            get() {
                return this.todoDetail.remindDate;
            },
            set(value) {
                this.todoDetail.remindDate = value
                this.update()
            },
        }
    },
    data() {
        return {
            // -- employee --
            searchValue: '',
            pageForEmployee: 1,
            listForEmployee: [],
            showEmployee: false,
            loadingForEmployee: false,
            finishedForEmployee: false,
            // -- time --
            showTime: false,
            dateTime: new Date(),
            minDate: new Date(), // 最小可选
            maxDate: new Date(2025, 10, 1), // 最大可选
            formatter(type, value) {
                if (type === "year") {
                    return `${value}年`;
                }
                if (type === "month") {
                    return `${value}月`;
                }
                if (type === "day") {
                    return `${value}日`;
                }
                return value;
            },
        }
    },
    methods: {
        update() {
            this.$emit("change", this.todoDetail);
        },
        showEmployeePopup() {
            this.showEmployee = true;
            this.loadEmployeeList()
        },
        // 获取顾客
        loadEmployeeList() {
            this.loadingForEmployee = true
            request({
                url: `/contact/wxContactPage?limit=10&page=${this.pageForEmployee}&searchStr=${this.searchValue}`,
                method: "get",
            })
                .then((res) => {
                    const { list, total } = res.data

                    this.listForEmployee = this.pageForEmployee === 1 ? list : this.listForEmployee.concat(list)
                    this.pageForEmployee += 1
                    // 数据全部加载完成
                    if (this.listForEmployee.length >= total) {
                        this.finishedForEmployee = true;
                    }
                })
                .catch((error) => {
                    this.listForEmployee = [];
                    this.finishedForEmployee = false
                    Toast({ position: 'top', message: error ?? '' })
                }).finally(() => {
                    this.loadingForEmployee = false
                })
        },
        employeeClick(employeeItem) {
            this.showEmployee = false;
            this.selectedEmployee = employeeItem
        },
        //搜索
        onSearch() {
            this.pageForEmployee = 1
            this.loadEmployeeList();
        },
        //清除
        onClear() {
            this.searchValue = "";
            this.pageForEmployee = 1
            this.loadEmployeeList();
        },
        // -- time
        showTimePopup() {
            if (this.remindDate) {
                this.dateTime = new Date(this.remindDate)
            }
            this.showTime = true
        },
        closeTimePopup() {
            this.showTime = false
        },
        onTimeConfirm(event) {
            this.remindDate = com.timeFormatNew(event, false);
            this.showTime = false
        },
        cancel() {
            this.showEmployee = false
        }
    },
}
</script>

<style scoped lang="less">
.todo-item {
    width: 690px;
    background: #ffffff;
    box-shadow: 0px 6px 26px 0px rgba(2, 2, 2, 0.08);
    border-radius: 16px;
    .area-box {
        position: relative;
        .descContent {
            width: 680px;
            height: 310px;
            border-radius: 16px;
            border: none;
            padding: 30px;
            color: #edeef0;
            box-sizing: border-box;
            font-size: 28px;
            margin-bottom: 40px;
            word-wrap: break-word;
        }
        .textarea-counter {
            position: absolute;
            bottom: 10px;
            right: 30px;
            width: 100px;
            font-size: 28px;
            font-weight: 400;
            color: #a0acb5;
            line-height: 40px;
        }
        :deep(textarea) {
            color: #a0acb5;
            -webkit-text-fill-color: #a0acb5; // ios 和 安卓9.0 必须添加此属性，才会生效
        }
    }

    .add-box {
        width: 630px;
        height: 70px;
        background: #e9f2ff;
        border-radius: 4px;
        font-size: 28px;
        font-weight: 400;
        color: #a0acb5;
        line-height: 70px;
        margin: 0 30px;
        padding: 0 20px;
        margin-bottom: 30px;
        .head-icon {
            width: 46px;
            height: 46px;
            border-radius: 50%;
            margin-right: 20px;
        }
    }

    .bottom-box {
        height: 100px;
        border-top: 1px solid #d7d7d7;
        font-size: 28px;
        padding: 0 30px;

        .time {
            margin-left: 20px;
            color: #35434c;
        }
        .follow {
            color: #35434c;
            margin-right: 10px;
        }
    }
}

.popup-container {
    margin: 0 30px;
    .title {
        margin-top: 32px;
        font-size: 34px;
    }
    :deep(.search-button.van-search) {
        padding: 20px 0;
    }
    :deep(.search-button .van-icon) {
        font-size: 28px;
    }
    :deep(.search-button .van-search__content) {
        padding-left: 20px !important;
    }
    :deep(.search-button .van-field__left-icon) {
        color: #c8c9cc !important;
        padding: 3px 20px 0 0 !important;
        margin-right: 0 !important;
    }
    :deep(.van-icon__image) {
        height: 28px;
        display: inline-block;
    }
    :deep(.van-field__control) {
        font-size: 28px !important;
    }
    .line {
        width: 690px;
        height: 110px;
        border-bottom: 1px solid #d7d7d7;
        font-size: 30px;
        font-weight: 400;
        color: #35434c;
        .head {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 20px;
        }
    }

    .save-button {
        width: 630px;
        height: 88px;
        background: #333f48;
        border-radius: 44px;
        font-size: 32px;
        font-weight: 400;
        color: #ffffff;
        margin: 80px auto;
    }
}
</style>
